exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tippy-tooltip.light-border-theme {\n  font-family: system-ui, sans-serif;\n}\n", ""]);

